import { applySimplifiedChineseFont, FontData } from './font-data-effect';

export type NameFontData = {
    value: string,
    labelKey: string,
    fontData: FontData,
};
const BaseNameFontDataMap: Record<'Default' | 'Arial' | 'OCG', NameFontData> = {
    Default: {
        value: 'Default',
        labelKey: 'input.name-style.font-type.default',
        fontData: {
            alphabetFont: 'MatrixRegularSmallCaps, Times New Roman',
            font: 'MatrixRegularSmallCaps, Times New Roman',
            fontStyle: 'tcg',
            furiganaFont: 'DFHSGothic-W3-WIN-RKSJ-H',
            headTextHeightRatio: 0.55,
            ordinalFont: '"DFKakuTaiHiStd-W4"',
            symbolFont: 'matrix, Times New Roman',
            symbolFontRatio: 0.775,
            vietnameseFont: 'MatrixRegularSmallCaps',
            vietnameseFontRatio: 1,
            arabicFontRatio: 0.75,
            variant: 'default-name',
            fontList: [{
                bulletWidth: 64,
                fontSize: 91,
                headTextFontRatio: 0.190,
                letterSpacing: 0.015,
                lineCount: 1,
                lineHeight: 91,
                offsetY: 0,
            }],
            letterOffsetMap: {
                '★': { ratio: 0.55, baseline: -0.05, yRatio: 1 },
                '☆': { ratio: 0.55, baseline: -0.05, yRatio: 1 },
                '¡': { ratio: 1, baseline: -0.098, edge: 0.02, yRatio: 0.58 },
            },
            letterDeviationMap: {
                'default': {
                    threshold: 0,
                    letterMap: {
                        '0': { baseLetter: '0' },
                        '1': { baseLetter: '1' },
                        '2': { baseLetter: '2' },
                        C: { baseLetter: 'C' },
                        Ć: { baseLetter: 'C' },
                        Ĉ: { baseLetter: 'C' },
                        Č: { baseLetter: 'C' },
                        Ċ: { baseLetter: 'C' },
                        Ḉ: { baseLetter: 'C' },
                        Ƈ: { baseLetter: 'C' },
                        C̈: { baseLetter: 'C' },
                        Ȼ̈: { baseLetter: 'C' },
                        Ç̈: { baseLetter: 'C' },
                        ć̈: { baseLetter: 'c' },
                        ĉ̈: { baseLetter: 'c' },
                        č̈: { baseLetter: 'c' },
                        ċ̈: { baseLetter: 'c' },
                        ḉ̈: { baseLetter: 'c' },
                        ƈ̈: { baseLetter: 'c' },
                        c̈̈: { baseLetter: 'c' },
                        ȼ̈: { baseLetter: 'c' },
                        ç̈: { baseLetter: 'c' },

                        Q: { baseLetter: 'O' },
                        Ɋ: { baseLetter: 'O' },
                        q: { baseLetter: 'o' },
                        ʠ: { baseLetter: 'o' },
                        ɋ: { baseLetter: 'o' },
                        q̃: { baseLetter: 'o' },

                        o: { baseLetter: 'o' },
                        ø: { baseLetter: 'o' },
                        ǿ: { baseLetter: 'o' },
                        ö: { baseLetter: 'o' },
                        ȫ: { baseLetter: 'o' },
                        ó: { baseLetter: 'o' },
                        ô: { baseLetter: 'o' },
                        ố: { baseLetter: 'o' },
                        ổ: { baseLetter: 'o' },
                        ỗ: { baseLetter: 'o' },
                        ǫ: { baseLetter: 'o' },
                        ȍ: { baseLetter: 'o' },
                        o̩: { baseLetter: 'o' },
                        ó̩: { baseLetter: 'o' },
                        ò̩: { baseLetter: 'o' },
                        ộ: { baseLetter: 'o' },
                        ǒ: { baseLetter: 'o' },
                        ṓ: { baseLetter: 'o' },
                        ṑ: { baseLetter: 'o' },
                        ỏ: { baseLetter: 'o' },
                        ō: { baseLetter: 'o' },
                        ṏ: { baseLetter: 'o' },
                        õ: { baseLetter: 'o' },
                        ṍ: { baseLetter: 'o' },
                        ő: { baseLetter: 'o' },
                        ŏ: { baseLetter: 'o' },
                        ȏ: { baseLetter: 'o' },
                        ȯ: { baseLetter: 'o' },
                        ȱ: { baseLetter: 'o' },
                        ơ: { baseLetter: 'o' },
                        ọ: { baseLetter: 'o' },
                        ồ: { baseLetter: 'o' },
                        ò: { baseLetter: 'o' },
                        Ɵ: { baseLetter: 'o' },
                        ɵ: { baseLetter: 'o' },
                        ỡ: { baseLetter: 'o' },
                        ớ: { baseLetter: 'o' },
                        ờ: { baseLetter: 'o' },
                        ở: { baseLetter: 'o' },
                        ȭ: { baseLetter: 'o' },
                        ợ: { baseLetter: 'o' },
                        ǭ: { baseLetter: 'o' },

                        O: { baseLetter: 'O' },
                        Ø: { baseLetter: 'O' },
                        Ǿ: { baseLetter: 'O' },
                        Ö: { baseLetter: 'O' },
                        Ȫ: { baseLetter: 'O' },
                        Ó: { baseLetter: 'O' },
                        Ò: { baseLetter: 'O' },
                        Ô: { baseLetter: 'O' },
                        Ố: { baseLetter: 'O' },
                        Ồ: { baseLetter: 'O' },
                        Ổ: { baseLetter: 'O' },
                        Ỗ: { baseLetter: 'O' },
                        Ộ: { baseLetter: 'O' },
                        Ǒ: { baseLetter: 'O' },
                        Ő: { baseLetter: 'O' },
                        Ŏ: { baseLetter: 'O' },
                        Ȏ: { baseLetter: 'O' },
                        Ȯ: { baseLetter: 'O' },
                        Ȱ: { baseLetter: 'O' },
                        Ọ: { baseLetter: 'O' },
                        Ơ: { baseLetter: 'O' },
                        Ớ: { baseLetter: 'O' },
                        Ờ: { baseLetter: 'O' },
                        Ỡ: { baseLetter: 'O' },
                        Ợ: { baseLetter: 'O' },
                        Ở: { baseLetter: 'O' },
                        Ỏ: { baseLetter: 'O' },
                        Ō: { baseLetter: 'O' },
                        Ṓ: { baseLetter: 'O' },
                        Ṑ: { baseLetter: 'O' },
                        Õ: { baseLetter: 'O' },
                        Ȭ: { baseLetter: 'O' },
                        Ṍ: { baseLetter: 'O' },
                        Ṏ: { baseLetter: 'O' },
                        Ǫ: { baseLetter: 'O' },
                        Ȍ: { baseLetter: 'O' },
                        O̩: { baseLetter: 'O' },
                        Ó̩: { baseLetter: 'O' },
                        Ò̩: { baseLetter: 'O' },
                        Ǭ: { baseLetter: 'O' },

                        I: { baseLetter: 'I' },
                        i: { baseLetter: 'i' },
                        Ì: { baseLetter: 'I' },
                        Í: { baseLetter: 'I' },
                        Î: { baseLetter: 'I' },
                        Ï: { baseLetter: 'I' },
                        ì: { baseLetter: 'i' },
                        í: { baseLetter: 'i' },
                        î: { baseLetter: 'i' },
                        ï: { baseLetter: 'i' },
                        Ĩ: { baseLetter: 'I' },
                        ĩ: { baseLetter: 'i' },
                        Ī: { baseLetter: 'I' },
                        ī: { baseLetter: 'i' },
                        Ỉ: { baseLetter: 'I' },
                        ỉ: { baseLetter: 'i' },
                        Ị: { baseLetter: 'I' },
                        ị: { baseLetter: 'i' },

                        E: { baseLetter: 'E' },
                        e: { baseLetter: 'e' },
                        È: { baseLetter: 'E' },
                        É: { baseLetter: 'E' },
                        Ê: { baseLetter: 'E' },
                        Ê̄: { baseLetter: 'E' },
                        Ê̌: { baseLetter: 'E' },
                        Ë: { baseLetter: 'E' },
                        è: { baseLetter: 'e' },
                        é: { baseLetter: 'e' },
                        ê: { baseLetter: 'e' },
                        ê̄: { baseLetter: 'e' },
                        ê̌: { baseLetter: 'e' },
                        ë: { baseLetter: 'e' },
                        Ē: { baseLetter: 'E' },
                        ē: { baseLetter: 'e' },
                        Ẻ: { baseLetter: 'E' },
                        ẻ: { baseLetter: 'e' },
                        Ẽ: { baseLetter: 'E' },
                        ẽ: { baseLetter: 'e' },
                        Ế: { baseLetter: 'E' },
                        ế: { baseLetter: 'e' },
                        Ề: { baseLetter: 'E' },
                        ề: { baseLetter: 'e' },
                        Ể: { baseLetter: 'E' },
                        ể: { baseLetter: 'e' },
                        Ễ: { baseLetter: 'E' },
                        ễ: { baseLetter: 'e' },
                        E̩: { baseLetter: 'E' },
                        e̩: { baseLetter: 'e' },
                        È̩: { baseLetter: 'E' },
                        É̩: { baseLetter: 'E' },
                        è̩: { baseLetter: 'e' },
                        Ẹ: { baseLetter: 'E' },
                        ẹ: { baseLetter: 'e' },
                        Ệ: { baseLetter: 'E' },
                        ệ: { baseLetter: 'e' },

                        N: { baseLetter: 'N' },
                        Ń: { baseLetter: 'N' },
                        Ñ: { baseLetter: 'N' },
                        Ň: { baseLetter: 'N' },
                        Ǹ: { baseLetter: 'N' },
                        Ṅ: { baseLetter: 'N' },
                        Ṇ: { baseLetter: 'N' },
                        Ņ: { baseLetter: 'N' },
                        Ṉ: { baseLetter: 'N' },
                        Ṋ: { baseLetter: 'N' },
                        Ꞥ: { baseLetter: 'N' },
                        n: { baseLetter: 'n' },
                        ń: { baseLetter: 'n' },
                        ñ: { baseLetter: 'n' },
                        ň: { baseLetter: 'n' },
                        ǹ: { baseLetter: 'n' },
                        ṅ: { baseLetter: 'n' },
                        ṇ: { baseLetter: 'n' },
                        ņ: { baseLetter: 'n' },
                        ṉ: { baseLetter: 'n' },
                        ṋ: { baseLetter: 'n' },
                        ꞥ: { baseLetter: 'n' },
                        ᵰ: { baseLetter: 'n' },
                        ᶇ: { baseLetter: 'n' },

                        G: { baseLetter: 'G' },
                    },
                },
            },
        },
    },
    Arial: {
        value: 'Arial',
        labelKey: 'input.name-style.font-type.arial',
        fontData: {
            alphabetFont: 'Arial',
            font: 'Arial',
            fontStyle: 'tcg',
            furiganaFont: 'DFHSGothic-W3-WIN-RKSJ-H',
            headTextHeightRatio: 0.825,
            ordinalFont: '"DFKakuTaiHiStd-W4"',
            symbolFont: 'matrix',
            symbolFontRatio: 0.775,
            vietnameseFont: 'Arial',
            vietnameseFontRatio: 1,
            weight: 'bold',
            variant: 'arial-name',
            fontList: [{
                bulletWidth: 40.67,
                fontSize: 61,
                headTextFontRatio: 0.190,
                letterSpacing: -0.14,
                lineCount: 1,
                lineHeight: 61,
                offsetY: 3,
            }],
        },
    },
    OCG: {
        value: 'OCG',
        labelKey: 'input.name-style.font-type.ocg',
        fontData: {
            alphabetFont: '"Yu-Gi-Oh! DF Leisho 3"',
            font: '"Yu-Gi-Oh! DF Leisho 3"',
            fontStyle: 'ocg',
            furiganaFont: 'DFHSGothic-W3-WIN-RKSJ-H',
            headTextBold: true,
            headTextHeightRatio: 0.775,
            headTextOverflow: 'condense',
            metricMethod: 'name',
            numberFont: 'DFKakuTaiHiStd-W4',
            numberFontRatio: 1.00,
            ordinalFont: '"DFKakuTaiHiStd-W4"',
            symbolFont: 'matrix',
            symbolFontRatio: 0.775,
            vietnameseFont: '"Yu-Gi-Oh! DF Leisho 3"',
            vietnameseFontRatio: 1,
            variant: 'ocg-name',
            fontList: [{
                bulletWidth: 42.67,
                fontSize: 64,
                headTextFontRatio: 0.175,
                headTextSpacing: 3,
                letterSpacing: -0.03,
                lineCount: 1,
                lineHeight: 64,
                offsetY: 0,
            }],
        }
    },
};

export const NameFontDataMap: Record<'Default' | 'Arial' | 'OCG' | 'SC', NameFontData> = {
    ...BaseNameFontDataMap,
    SC: {
        value: 'SC',
        labelKey: 'input.name-style.font-type.sc',
        fontData: applySimplifiedChineseFont(BaseNameFontDataMap.OCG.fontData, 'sc-name'),
    },
};
